import * as THREE from 'three';
import type { SketchGroup, SketchPointObject } from '../../../mesh/sketch';

/**
 * 草图缩放手柄枚举。
 */
export enum SketchScaleHandleId {
    /** 左上手柄。 */
    TopLeft = 'top-left',
    /** 上中手柄。 */
    TopCenter = 'top-center',
    /** 右上手柄。 */
    TopRight = 'top-right',
    /** 左中手柄。 */
    MiddleLeft = 'middle-left',
    /** 右中手柄。 */
    MiddleRight = 'middle-right',
    /** 左下手柄。 */
    BottomLeft = 'bottom-left',
    /** 下中手柄。 */
    BottomCenter = 'bottom-center',
    /** 右下手柄。 */
    BottomRight = 'bottom-right',
}

/**
 * 缩放手柄游标枚举。
 */
export enum SketchScaleCursor {
    /** 默认箭头。 */
    Default = 'default',
    /** 对角缩放（↘↖）。 */
    DiagonalNwse = 'nwse-resize',
    /** 对角缩放（↗↙）。 */
    DiagonalNesw = 'nesw-resize',
    /** 水平缩放。 */
    Horizontal = 'ew-resize',
    /** 垂直缩放。 */
    Vertical = 'ns-resize',
}

/**
 * 草图缩放调试叠加层模式枚举。
 */
export enum SketchScaleDebugOverlayMode {
    /** 关闭调试叠加层。 */
    Off = 'off',
    /** 显示缩放边界、参与计算点与手柄落点。 */
    Bounds = 'bounds',
}

/**
 * 草图平面基。
 */
export interface SketchPlaneBasis {
    /** 平面原点。 */
    origin: THREE.Vector3;
    /** 平面 X 轴。 */
    xAxis: THREE.Vector3;
    /** 平面 Y 轴。 */
    yAxis: THREE.Vector3;
    /** 平面法线。 */
    normal: THREE.Vector3;
}

/**
 * 草图二维包围盒。
 */
export interface SketchBounds2D {
    /** 最小 X。 */
    minX: number;
    /** 最大 X。 */
    maxX: number;
    /** 最小 Y。 */
    minY: number;
    /** 最大 Y。 */
    maxY: number;
}

/**
 * 点位快照。
 */
export interface SketchPointSnapshot {
    /** 点对象。 */
    point: SketchPointObject;
    /** 缩放前世界坐标。 */
    world: THREE.Vector3;
}

/**
 * 缩放拖拽状态。
 */
export interface SketchScaleDragState {
    /** 当前草图 ID。 */
    sketchId: string;
    /** 当前拖拽手柄。 */
    handleId: SketchScaleHandleId;
    /** 草图平面基。 */
    basis: SketchPlaneBasis;
    /** 锚点 UV。 */
    anchorUv: THREE.Vector2;
    /** 缩放倍率参考锚点 UV。 */
    scaleAnchorUv: THREE.Vector2;
    /** 拖拽起始手柄 UV。 */
    startHandleUv: THREE.Vector2;
    /** 点位快照。 */
    pointSnapshots: SketchPointSnapshot[];
    /** 当前草图组。 */
    sketchGroup: SketchGroup;
}
